import React from 'react';
import Section from './section';

function HLine(){
    return (
        <hr className="sec-end"></hr>
      );
}

export default HLine;